import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, RouterEvent, NavigationEnd } from '@angular/router';
import { BlogService } from 'src/app/services/blog.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api.service';
import { TagService } from 'src/app/services/tag.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  selector: 'app-detail-left-sidebar',
  templateUrl: './detail-left-sidebar.component.html',
  styleUrls: ['./detail-left-sidebar.component.scss']
})
export class DetailLeftSidebarComponent implements OnInit, OnDestroy {
  blogData: any = {}
  public destroyed = new Subject<any>()
  shareablePlatforms = ['facebook', 'whatsapp', 'telegram', 'line', 'copy']
  defaultImage = `https://dummyimage.com/835x430/9e9e9e.jpg&text=+`

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public blogService: BlogService,
    private translateService: TranslateService,
    private apiService: ApiService,
    private tagService: TagService,
    private sanitizer: DomSanitizer,
  ) {
    this.initialize()
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)
    ).subscribe(() => {
      this.initialize()
    })
    this.translateService.onLangChange.subscribe(data => {
      this.getBlog()
    })
  }

  ngOnDestroy() {
    this.destroyed.next()
    this.destroyed.complete()
  }

  initialize() {
    let blog = this.route.snapshot.data['blog']
    if(blog && blog.title) {
      this.blogData = blog
      this.blogData['content'] = this.sanitizer.bypassSecurityTrustHtml(this.blogData['content'])
      this.tagService.setTitle(`${this.blogData.title} | Ezane Mortgage`)
      this.tagService.setMetaTags([
        { name: 'description', content: this.blogData['description'] },
        { property: 'og:title', content: `${this.blogData['title']} | Ezane Mortgage` },
        { property: 'og:description', content: this.blogData['description'] },
        { property: 'og:url', content: `${environment.DOMAIN}/blog/${this.blogData['code']}` },
        { property: 'og:image', content: decodeURIComponent(this.blogData['cover']) },
        { property: 'og:image:secure_url', content: decodeURIComponent(this.blogData['cover']) },
        { property: 'og:image:width', content: '830' },
        { property: 'og:image:height', content: '435' },
        { property: 'og:image:alt', content: `${this.blogData.title} | Ezane Mortgage` },
        { name: 'twitter:title', content: `${this.blogData['title']} | Ezane Mortgage` },
        { name: 'twitter:description', content: this.blogData['description'] },
        { name: 'twitter:image', content: decodeURIComponent(this.blogData['cover']) },
        { name: 'twitter:image:alt', content: `${this.blogData.title} | Ezane Mortgage` },
        { name: 'twitter:url', content: `${environment.DOMAIN}/blog/${this.blogData['code']}` },
      ])
      this.tagService.addMetaTags([
        { property: 'article:published_time', content: this.blogData['createdAt'] },
        { property: 'article:article:modified_time', content: this.blogData['updatedAt'] },
      ])
    }
    else {
      this.router.navigate(['/blog'])
    }
  }

  getBlog() {
    this.apiService.get(`${environment.API}/api/v1/public/blog/${this.route.snapshot.paramMap.get('code')}?language=${this.translateService.currentLang}`).subscribe(
      data => {
        this.blogData = data
      },
      err => {
        console.error(err)
      }
    )
  }
  
  filterByCategory = (category) => {
    this.router.navigate(['/blog'], { state: { category } })
  }

}
